import { useCallback, useState } from 'react';
import { useAppDispatch } from '../../core/hooks/storeHooks';
import { GridEntity } from '../types';
import { MenuState, useMenuState } from '@szhsin/react-menu';
import { IPosition2d } from '../../core/types/ui/position';
import { HeaderGroup } from '../types/sheet/headerGroups';
import {
  GridCommand,
  SheetCommand,
} from '../types/commands/sheetCommands/sheetCommands';
import { handleSheetOperations } from '../redux/sagas/root/rootActions';

interface ContextMenuState extends IPosition2d {
  group?: HeaderGroup;
  entityType?: GridEntity;
}

interface IOpenContextMenuParams {
  clientX: number;
  clientY: number;
  entityType?: GridEntity;
  group?: HeaderGroup;
}

export interface UseGridOperations {
  // performGridOperation: (
  //   entity: GridEntity,
  //   operationData: any // TODO: Replace it with SheetCommand
  // ) => void;
  // performCellOperation: (operationData: any) => void;
  performSheetOperation(command: SheetCommand): void;
  menuState: {
    state?: MenuState;
    endTransition: () => void;
  };
  contextMenuState: ContextMenuState;
  openContextMenu: (
    e?: React.MouseEvent,
    params?: Partial<IOpenContextMenuParams>
  ) => void;
  closeContextMenu: () => void;
}

export default (sheetId: string, focusSheet: () => void): UseGridOperations => {
  const [menuState, toggleContextMenu] = useMenuState({
    unmountOnClose: true,
  });
  // const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });

  const [contextMenuState, setContextMenuState] = useState<ContextMenuState>({
    x: 0,
    y: 0,
  });

  const dispatch = useAppDispatch();

  const performSheetOperation = useCallback(
    (command: SheetCommand) => {
      // console.log("command", command)
      dispatch(handleSheetOperations(command));
    },
    [sheetId]
  );

  // const performGridOperation = useCallback(
  //   (entity: GridEntity, op: GridCommand) => {
  //     // operationData: GridOperationData
  //     // dispatch(
  //     //   handleGridOperationsAc({
  //     //     sheetId,
  //     //     entityType,
  //     //     operationData,
  //     //   })
  //     // );
  //   },
  //   [sheetId]
  // );

  // const performCellOperation = useCallback((operationData: any) => {
  //   // dispatch(
  //   //   handleCellOperationsAc({
  //   //     sheetId,
  //   //     operationData,
  //   //   })
  //   // );
  // }, []);

  const openContextMenu = useCallback(
    (e?: React.MouseEvent, params?: Partial<IOpenContextMenuParams>) => {
      e?.preventDefault();

      setContextMenuState({
        x: params?.clientX ?? e?.clientX ?? 0,
        y: params?.clientY ?? e?.clientY ?? 0,
        entityType: params?.entityType,
        group: params?.group,
      });

      toggleContextMenu(true);
    },
    [toggleContextMenu]
  );

  const closeContextMenu = () => {
    toggleContextMenu(false);
    focusSheet();
  };

  return {
    menuState,
    contextMenuState,
    performSheetOperation,
    openContextMenu,
    closeContextMenu,
  };
};
